export const FOOTER_PARTNER_LINKS = [
  {
    href: 'https://imgedify.com/?via=aitoolly.com',
    label: 'ImgEdify AI Image & Video Generator',
  },
  {
    href: 'https://aitalk.im/?via=aitoolly.com',
    label: 'AITalk - AI Language Tutor',
  },
  {
    href: 'https://ariaflow.ai/?utm_source=aitoolly.com&utm_medium=referral&utm_campaign=site_footer',
    label: 'Ariaflow-AI Faceless Video Generator',
  },
] as const;
